// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}\n._bfhkhp5a{background-color:var(--ds-surface-raised,#fff)}\n._irr31a0f:hover{background-color:var(--ds-surface-raised-hovered,#f1f2f4)}", ""]);
// Exports
module.exports = exports;
